import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppState } from '../model/reducer';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { NavigationService } from '../navbar/navigation.service';
import { InventoryService } from './inventory.service';
import { ModalNotificationService } from '../notification/modal-notification.service';
import { Mixin } from '../common/decorators/mixin.decorator';
import { IInventoryGuardMixin, InventoryGuardMixin } from '../common/mixins/inventory-guard.mixin';
import _ from 'lodash';
import { NevisAdminAction } from '../model/actions';

@Injectable({
  providedIn: 'root'
})
@Mixin([InventoryGuardMixin])
export class InventorySettingsGuard  implements IInventoryGuardMixin {
  store$ = inject<Store<AppState>>(Store);
  actions$ = inject<Actions<NevisAdminAction<any>>>(Actions);
  navigationService = inject(NavigationService);
  inventoryService = inject(InventoryService);
  modalNotificationService = inject(ModalNotificationService);


  // implemented by the mixin
  canActivateInventoryScreen: (next: ActivatedRouteSnapshot) => Observable<boolean>;

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canActivateInventoryScreen(next);
  }

  public navigateToInventoryScreen(inventoryKey?: string): Promise<boolean> {
    return this.navigationService.navigateToInventorySettings(inventoryKey);
  }

  public showCannotOpenInventoryWindow(inventoryKey: string, additionalText?: string): void {
    const title = `Could not open inventory settings for ${inventoryKey}`;
    const secondLine: string = _.isNil(additionalText) ? '' : `<br>${additionalText}`;
    this.modalNotificationService.openErrorDialog({title: title, description: `The inventory-settings does not exist or you are not permitted to view it.${secondLine}`});
  }

}
